import { combineReducers } from 'redux';
import toast from './SnackBar/SuccessSnack/reducer';
import CurrentUser from './CurrentUser/reducer';

export const rootReducer = combineReducers({
  toast,
  CurrentUser
});
